import { useEffect } from "react";

// Keeps `activeRowItem` synced to whatever row `rowSelection` (a Material
// React Table selection object keyed by row index -- Action List's table has
// no getRowId) points to in the CURRENT listData.
export function useActiveRowItemSync(
  listData: any[] | undefined,
  rowSelection: Record<string, boolean>,
  setActiveRowItem: (item: any) => void,
) {
  useEffect(() => {
    const keys = Object.keys(rowSelection);
    const selectedRow = keys.length > 0 ? listData?.[Number(keys[0])] ?? null : null;
    setActiveRowItem(selectedRow);
    // Re-run on listData changes too (not just rowSelection) -- completing/
    // updating the selected action refetches listData without touching
    // rowSelection, so a [rowSelection]-only effect never re-fired and kept
    // showing the pre-refresh row (root cause of the stale detail panel bug).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowSelection, listData]);
}
